import React from 'react';
import Google from '../../../../../../resources/images/png/google.png';
import { ReactComponent as Facebook } from '../../../../../../resources/images/svg/whiteFacebook.svg';
import useTranslation from '../../../../../hooks/translation/useTranslation';

const socialAuthButtonClass = 'flex h-[60px] justify-center items-center border-0 bg-white grow rounded-lg gap-[10px]';

function SocialAuthButtons() {
  const { trans } = useTranslation();

  const handleMobileAuth = () => {
    localStorage.setItem('afterOAuthRedirectUrl', window.location.href);
    if (window?.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(JSON.stringify({ type: 'googleOAuth' }));
    }
  };

  return (
    <div className="flex gap-4">
      {
            window?.ReactNativeWebView
              ? (
                <button
                  type="button"
                  onClick={handleMobileAuth}
                  className={socialAuthButtonClass}
                >
                  <img src={Google} alt="Google" />
                  <p className="m-0 text-base hidden lg:block">{trans('login-google')}</p>
                </button>
              )
              : (
                <a href="/api/auth/google" onClick={handleMobileAuth} className={socialAuthButtonClass}>
                  <img src={Google} alt="Google" />
                  <p className="m-0 text-base hidden lg:block">{trans('login-google')}</p>
                </a>
              )
        }
      <a href="/api/auth/facebook" onClick={handleMobileAuth} className={socialAuthButtonClass} style={{ background: '#1877F2' }}>
        <Facebook />
        <p className="m-0 text-base text-white hidden lg:block">{trans('login-facebook')}</p>
      </a>
    </div>
  );
}

export default SocialAuthButtons;
